import type { FormSelectOption } from '@practium/ui';

export const CULTURE_OPTIONS: FormSelectOption[] = [
	{ value: 'cafeArabica', label: 'Café Arábica' },
	{ value: 'cafeConilon', label: 'Café Conilon' },
];

export const IRRIGATION_OPTIONS: FormSelectOption[] = [
	{ value: 'none', label: 'Sem Irrigação' },
	{ value: 'drip', label: 'Gotejamento' },
	{ value: 'sprinkler', label: 'Aspersão' },
	{ value: 'microSprinkler', label: 'Microaspersão' },
	{ value: 'pivot', label: 'Pivô' },
];

export const BRAZILIAN_STATES: string[] = [
	'Acre',
	'Alagoas',
	'Amapá',
	'Amazonas',
	'Bahia',
	'Ceará',
	'Distrito Federal',
	'Espírito Santo',
	'Goiás',
	'Maranhão',
	'Mato Grosso',
	'Mato Grosso do Sul',
	'Minas Gerais',
	'Pará',
	'Paraíba',
	'Paraná',
	'Pernambuco',
	'Piauí',
	'Rio de Janeiro',
	'Rio Grande do Norte',
	'Rio Grande do Sul',
	'Rondônia',
	'Roraima',
	'Santa Catarina',
	'São Paulo',
	'Sergipe',
	'Tocantins',
];

export const STATE_OPTIONS: FormSelectOption[] = BRAZILIAN_STATES.map(s => ({
	value: s,
	label: s,
}));

export const CULTURE_LABELS: Record<string, string> = {
	cafeArabica: 'Café Arábica',
	cafeConilon: 'Café Conilon',
};

export const IRRIGATION_LABELS: Record<string, string> = {
	none: 'Sem Irrigação',
	drip: 'Gotejamento',
	sprinkler: 'Aspersão',
	microSprinkler: 'Microaspersão',
	pivot: 'Pivô',
};
